import * as Slider from '@radix-ui/react-slider';
import clsx from 'clsx';

export type DoubleRangeProps = {
  value: number[];
  defaultValue?: number[];
  minValue: number;
  maxValue: number;
  onValueChange?: (value: number[]) => void;
  onValueCommit?: (value: number[]) => void;
  disabled?: boolean;
};

export function DoubleRangeSlider({
  value,
  defaultValue,
  minValue,
  maxValue,
  onValueChange,
  onValueCommit,
  disabled,
}: DoubleRangeProps) {
  return (
    <Slider.Root
      className={clsx(
        'relative flex h-4 w-full touch-none select-none items-center',
        {
          'pointer-events-none opacity-25': disabled,
        }
      )}
      value={value}
      min={minValue}
      max={maxValue}
      defaultValue={defaultValue}
      minStepsBetweenThumbs={1}
      onValueChange={(v) => !disabled && onValueChange && onValueChange(v)}
      onValueCommit={(v) => !disabled && onValueCommit && onValueCommit(v)}
      disabled={disabled}
    >
      <Slider.Track className="relative h-1 flex-grow rounded-full bg-neutral-50">
        <Slider.Range className="absolute h-full rounded-full bg-neutral-80" />
      </Slider.Track>
      <Slider.Thumb
        className="block h-4 w-4 rounded-full border bg-neutral-80 bg-grey-base focus:outline-none focus:ring"
        aria-label="Minimum"
      />
      <Slider.Thumb
        className="block h-4 w-4 rounded-full border bg-neutral-80 focus:outline-none focus:ring"
        aria-label="Maksimum"
      />
    </Slider.Root>
  );
}

export default DoubleRangeSlider;
